import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { isNotNil } from 'utils/ramdaUtils';

import { getTravelLines } from 'RestAPIs/arrangements';

import { showSnackbar } from 'components/shared';

export const useGetTravelLines = (trvSetId) => {
  const { t } = useTranslation('common');

  return useQuery({
    enabled: isNotNil(trvSetId),
    queryKey: ['getTravelLines', trvSetId],
    queryFn: async () =>
      await getTravelLines(trvSetId).then((response) => response.data),
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('errorDuringFetching')
      });
    }
  });
};
